import { VerticalNavigation } from "@mds/mds-reactjs-library";
import Wrapper from "./SideMenu.style";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useMemo, useState } from "react";
import { NavigationRoutes } from "../../../Constants/Routes";

const SideMenu = ({ chartCategories, chartBaseRoute = NavigationRoutes.VISUALIZE }) => {
    const navigate = useNavigate();
    const params = useParams();
    const [visible, setVisible] = useState(false);
    const queryParams = new URLSearchParams(window.location.search);
    const title = decodeURIComponent(queryParams.get('menutitle'));
    const currentPathParam = queryParams.get('path')
        ? decodeURIComponent(queryParams.get('path'))
        : queryParams.get('category')
            ? decodeURIComponent(queryParams.get('category'))
            : null;
    const categories = Array.isArray(chartCategories) ? chartCategories : [];

    useEffect(() => {
        if (categories.length > 0) setVisible(true);
    }, [categories.length]);

    const goToChart = (chart, categoryDisplayName) =>
        navigate(chartBaseRoute + '/' + (chart.routeId ?? chart.title.split(' ').join('-')) + '?path=' + encodeURIComponent(categoryDisplayName));

    const navigationItems = useMemo(() => categories.map((category, index) => {
        const charts = Array.isArray(category.charts) ? category.charts : [];
        const hasSingleMatchingChart = charts.length === 1
            && (charts[0]?.title || '').trim().toLowerCase() === (category?.displayName || '').trim().toLowerCase();

        if (hasSingleMatchingChart) {
            const chart = charts[0];
            return {
                id: chart.routeId ?? chart.name ?? chart.title,
                label: chart.title,
                active: params.name?.toLowerCase() === (chart.routeId ? chart.routeId.toLowerCase() : chart.title?.toLowerCase().split(' ').join('-')),
                onClick: () => { goToChart(chart, category.displayName); },
            };
        }

        return {
            id: category.displayName,
            label: category.displayName,
            expanded: (index === 0 || title?.toLowerCase() === category?.displayName?.split(' ').join('-').toLowerCase()),
            items: charts.map(chart => ({
                id: chart.name,
                label: chart.title,
                active : params.name?.toLowerCase() === (chart.routeId ? chart.routeId.toLowerCase() : chart.title?.toLowerCase().split(' ').join('-')) &&
                         (!currentPathParam || currentPathParam === category.displayName),
                onClick : () => { goToChart(chart, category.displayName); }
            }))
        };
    }), [categories, currentPathParam, params.name, title]);

    return (
        <Wrapper visible={visible}>
            <VerticalNavigation items={navigationItems} />
        </Wrapper>
    );
}

export default SideMenu;